import { ContestStatuses } from '../../../enums';
import { resources } from '../../../resources/resources';

export const getLabelResource = (status: ContestStatuses) => {
  if (status === ContestStatuses.CustomerNotRegistered)
    return resources.contests.registerNow;
  return resources.seeDetails;
};
